
import type { PropType } from 'vue'

import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

import DwButton from '@/modules/DispatcherWorkplaceModule/ui/DwButton/index.vue'
import DwDate from '@/modules/DispatcherWorkplaceModule/ui/DwDate/index.vue'
import DwSelect from '@/modules/DispatcherWorkplaceModule/ui/DwSelect/index.vue'

export default defineComponent({
    components: {
        DwButton,
        DwDate,
        DwSelect,
    },
    props: {
        date: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
        dispatcherSectorId: {
            type: [Number, null] as PropType<number | null>,
            default: null,
        },
        dispatcherSectors: {
            type: Array as PropType<any[]>,
            default: () => []
        },
        dispatcherSectorsLoading: {
            type: Boolean,
            default: false,
        },
        dispatcherSectorsFailed: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['date-changed', 'dispatcher-sector-changed', 'open-self-pickup', 'open-self-delivery', 'reload'],
    setup(props, { emit }) {
        const router = useRouter()

        const onGoToBpms = () => {
            router.push('/')
        }

        const onReload = () => {
            emit('reload')
        }

        const onDateChanged = (date: string) => {
            emit('date-changed', date)
        }

        const onDispatcherSectorChanged = (dispatcher_sector_id: number) => {
            emit('dispatcher-sector-changed', dispatcher_sector_id)
        }
        
        const onOpenSelfPickup = () => {
            emit('open-self-pickup')
        }

        const onOpenSelfDelivery = () => {
            emit('open-self-delivery')
        }

        return {
            onReload,
            onGoToBpms,
            onDateChanged,
            onDispatcherSectorChanged,
            onOpenSelfPickup,
            onOpenSelfDelivery,
        }
    }
})
